import { Spinner } from 'react-bootstrap'
import styled from 'styled-components'

interface IProps {
  animation?: 'grow' | 'border'
  variant?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark'
  size?: number
  className?: string
}

export const LoadingAnimation = ({ animation, size = 1, className, variant }: IProps) => {
  return <StyledSpinner animation={animation || 'grow'} variant={variant || 'info'} size={size} className={className} />
}

const StyledSpinner = styled(Spinner)<IProps>`
  width: ${({ size }) => (size || 1) * 1}rem;
  height: ${({ size }) => (size || 1) * 1}rem;
`
